
export function MicrosoftLogo(props?: React.SVGProps<SVGSVGElement>) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 16 16" fill="none" role="img" aria-label="Microsoft logo" {...props}>
            <rect x="8.5" y="8.5" width="5" height="5" fill="#FEBA08"/>
            <rect x="2.5" y="8.5" width="5" height="5" fill="#05A6F0"/>
            <rect x="8.5" y="2.5" width="5" height="5" fill="#80BC06"/>
            <rect x="2.5" y="2.5" width="5" height="5" fill="#F25325"/>
        </svg>
    );
}
